/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Operator } from './operator';
import { SearchAttributeSuggestedQueryUrl } from './searchAttributeSuggestedQueryUrl';

export interface SearchAttribute { 
    /**
     * Visible name & identifier.
     */
    name: string;
    type: SearchAttribute.TypeEnum;
    /**
     * Visible names of operators & identifiers.
     */
    operators: Array<Operator>;
    suggested_query_url?: SearchAttributeSuggestedQueryUrl;
    /**
     * Список suggested elements. Должны интерпретироваться в зависимости от type. Не может быть одновременно с suggested_query_url.
     */
    suggested_values?: Array<string>;
    default_selection?: string;
}
export namespace SearchAttribute {
    export type TypeEnum = 'string' | 'geo' | 'number';
    export const TypeEnum = {
        String: 'string' as TypeEnum,
        Geo: 'geo' as TypeEnum,
        Number: 'number' as TypeEnum
    };
}